import type { Parameter, PayHubCashierContractsInitParamsResponse } from 'store/models';
import {
  PayHubAdminPanelDomainCurrenciesEnumsCashierMethodParamType,
  PayHubAdminPanelDomainEnumsParameterDataType,
} from 'store/models';

export const formRouteRequiredFields = (
  parameters: PayHubCashierContractsInitParamsResponse[] | null | undefined,
): Parameter[] | [] => {
  if (!parameters || parameters.length === 0) {
    return [];
  }

  return parameters.map(
    ({
      name,
      type,
      extended_type,
      data_type,
      regexp,
      label,
      place_holder,
      place_holder_empty_list,
      place_holder_empty_list_error,
      is_required,
      is_otp_requisites,
      options,
      user_requisite,
      validation_msg_key,
      is_read_only,
    }: PayHubCashierContractsInitParamsResponse): Parameter => {
      const formattedOptions =
        options && options.length
          ? options.map((option) => ({
              ...option,
              selected: option.is_selected || false,
              name: option.label || '',
              value: option.value || '',
            }))
          : undefined;

      return {
        name: name || '',
        key: name || JSON.stringify(label),
        type: type || PayHubAdminPanelDomainCurrenciesEnumsCashierMethodParamType.Input,
        extendedType: extended_type,
        dataType: data_type || PayHubAdminPanelDomainEnumsParameterDataType.String,
        regexp: regexp || undefined,
        label,
        placeHolder: place_holder,
        placeHolderEmptyList: place_holder_empty_list,
        placeHolderEmptyListError: place_holder_empty_list_error,
        isRequired: is_required,
        isOtpRequisites: is_otp_requisites,
        options: formattedOptions,
        userRequisite: user_requisite || null,
        validationMsgKey: validation_msg_key,
        isDisabled: is_read_only,
      };
    },
  );
};
